module.exports = __webpack_public_path__ + "a6dd30beb7cfc357cfea86371b0eed77.png";